import { useEffect, useState } from "react";
import { BACKEND_UNAVAILABLE_EVENT } from "@/lib/supabase";

/**
 * Global banner shown when the auth backend becomes unreachable (timeout in
 * getSessionSafe). Mounted once at the app root so it shows up on whatever
 * route the user ends up on (typically /login, via the requireAuth guard's
 * redirect).
 */
export function BackendStatusBanner(): JSX.Element | null {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const handleUnavailable = (): void => setVisible(true);
    window.addEventListener(BACKEND_UNAVAILABLE_EVENT, handleUnavailable);
    return () => window.removeEventListener(BACKEND_UNAVAILABLE_EVENT, handleUnavailable);
  }, []);

  if (!visible) {
    return null;
  }

  return (
    <div
      role="alert"
      className="fixed inset-x-0 top-0 z-[100] bg-destructive px-4 py-2 text-center text-sm font-medium text-destructive-foreground"
    >
      Servidor indisponível no momento, tente novamente em instantes.
    </div>
  );
}
